// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__cqYun","content":"style_content__uiJcV","button":"style_button__U5MRA","title":"style_title__Dt-1C","info":"style_info__W0a+z"};